import { Box, Flex, Icon } from '@chakra-ui/react';

const IconLabel = ({ fontSize, icon, label, gap = 1, bg = 'transparent', color = 'black' }) => {
  return (
    <Flex alignItems="center" gap={gap} fontSize={fontSize} bg={bg} color={color}>
      <Icon as={icon} />
      <Box>{label}</Box>
    </Flex>
  );
};

export default IconLabel;
